export default "__VITE_ASSET__VcHgWkKV__"